import { createSelector } from "reselect";

import { getShipmentLtl } from "./getShipmentLtl";

export const getSelectedQuoteData = createSelector(getShipmentLtl, (shipmentLtl) =>
  shipmentLtl.quotes.find((quote) => quote.id === shipmentLtl?.selectedQuoteId)
);
